import {
  getNumberValuesToCompare,
  greaterThan,
  isArrayOfNumbers,
  isValueEmpty,
} from '../utils';

export function valueIsGreaterThan(
  givenValue: any,
  expectedValue: any,
  orEqual: boolean = false,
): boolean {
  if (isValueEmpty(givenValue)) {
    return false;
  }

  const values = getNumberValuesToCompare(givenValue, expectedValue);

  if (isArrayOfNumbers(values)) {
    const [given, expected] = values;
    return greaterThan(given, expected, orEqual);
  }

  throw new Error(
    `GreaterThan operator: Unsupported values to compare ${givenValue}, ${expectedValue}`,
  );
}
